import { gql } from '@apollo/client'

export const SEND_LOGIN_LINK = gql`
  mutation sendLoginLink($input: SendLoginLinkInput!) {
    sendLoginLink(input: $input) {
      errors {
        message
        code
      }
    }
  }
`
